import React from 'react'; // Remova 'Link' se não for necessário.
import '../styles/Política.css'; // Arquivo de estilos

function Politica() {
  return (
    <div className="terms-container">
      <h1>Política de Privacidade e LGPD</h1>
      <p>
        A sua privacidade é importante para nós. Este documento descreve como coletamos, utilizamos e protegemos suas informações, em conformidade com a Lei Geral de Proteção de Dados (LGPD).
      </p>
      <h2>Coleta de Dados</h2>
      <p>
        Coletamos informações pessoais fornecidas diretamente por você, como nome, e-mail e telefone, ao preencher formulários ou utilizar nossos serviços. Também podemos coletar dados automaticamente, como informações de navegação, por meio de cookies e tecnologias semelhantes.
      </p>
      <h2>Uso dos Dados</h2>
      <p>
        Utilizamos os dados coletados para os seguintes propósitos:
      </p>
      <ul>
        <li>Fornecer e personalizar nossos serviços;</li>
        <li>Entrar em contato para suporte ou informações solicitadas;</li>
        <li>Melhorar nosso site e serviços com base em suas preferências.</li>
      </ul>
      <h2>Compartilhamento de Dados</h2>
      <p>
        Não compartilhamos suas informações pessoais com terceiros, exceto quando necessário para cumprir exigências legais ou para fornecer os serviços contratados.
      </p>
      <h2>Seus Direitos</h2>
      <p>
        De acordo com a LGPD, você tem os seguintes direitos:
      </p>
      <ul>
        <li>Acessar os dados que temos sobre você;</li>
        <li>Corrigir informações incorretas ou desatualizadas;</li>
        <li>Solicitar a exclusão de seus dados pessoais, salvo em casos previstos por lei;</li>
        <li>Revogar consentimentos fornecidos anteriormente.</li>
      </ul>
      <h2>Segurança dos Dados</h2>
      <p>
        Implementamos medidas técnicas e organizacionais para proteger seus dados contra acesso não autorizado, perda ou uso indevido. No entanto, nenhum sistema é completamente seguro, e não podemos garantir segurança absoluta.
      </p>
      <h2>Cookies</h2>
      <p>
        Utilizamos cookies para melhorar sua experiência no site. Você pode configurar seu navegador para recusar alguns ou todos os cookies, mas isso pode impactar a funcionalidade do site.
      </p>
      <h2>Alterações nesta Política</h2>
      <p>
        Podemos atualizar esta política de privacidade periodicamente. Recomendamos que você revise esta página regularmente para se manter informado sobre nossas práticas.
      </p>
      <h2>Contato</h2>
      <p>
        Para dúvidas ou solicitações relacionadas à privacidade e proteção de dados, entre em contato pelo e-mail: <a href="mailto:contato@lf.dev.br">contato@lf.dev.br</a>.
      </p>
    </div>
  );
}

export default Politica;
